import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEquiposJuegosAction,
  deleteEquiposJuegosAction,
  setActivoEquiposJuegosAction,
} from '../EquiposJuegosAction';
import { PARAMS_EQUIPOS_JUEGOS } from '../EquiposJuegosReducer';
import ExpandedEquiposJuegosComponent from './ExpandedEquiposJuegos';

const ListadoEquiposJuegos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const torneosStore = Redux.useSelector((state) => state.torneos);
  const equiposJuegosStore = Redux.useSelector((state) => state.equiposJuegos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...equiposJuegosStore.params,
        idTorneo: torneosStore.activo.id,
      };
      dispatch({ type: PARAMS_EQUIPOS_JUEGOS, payload });

      if (equiposJuegosStore.all && equiposJuegosStore.all.length === 0) {
        await allEquiposJuegosAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    equiposJuegosStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        grupo: el.juego.grupo,
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [equiposJuegosStore.all]);

  const _handleEditClick = async (id) => {
    const data = equiposJuegosStore.all.find((el) => el.id === id);
    await setActivoEquiposJuegosAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteEquiposJuegosAction(
      { dispatch, notify },
      equiposJuegosStore.activo.id,
      equiposJuegosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  function getDataStore(id) {
    return equiposJuegosStore.all.find((el) => el.id === id);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.equipo.name,
      label: CONST.equipo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.resultado.name,
      label: CONST.resultado.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.ganador.name,
      label: CONST.ganador.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value && <Chip label="Ganador" size="small" color="success" />;
        },
      },
    },
    {
      name: CONST.juego.name,
      label: CONST.juego.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.fechaHora}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.ronda.name,
      label: CONST.ronda.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography
            // onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value.nombre}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.grupo.name,
      label: CONST.grupo.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  setActivoEquiposJuegosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = equiposJuegosStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedEquiposJuegosComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={equiposJuegosStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {equiposJuegosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {equiposJuegosStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEquiposJuegos;
